import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { utcDateToTimezoneDisplayDate } from '../utils/timezone.helper';

@Pipe({
  name: 'eventDateTime',
  standalone: true,
})
export class EventDateTimePipe implements PipeTransform {
  protected readonly datePipe = new DatePipe('en');
  transform(
    startDate: Date,
    endDate: Date,
    siteTimeZone?: string | null
  ): string {
    const roomStartDate = utcDateToTimezoneDisplayDate(startDate, siteTimeZone);
    const roomEndDate = utcDateToTimezoneDisplayDate(endDate, siteTimeZone);
    const sameDay =
      roomStartDate.getFullYear() === roomEndDate.getFullYear() &&
      roomStartDate.getMonth() === roomEndDate.getMonth() &&
      roomStartDate.getDate() === roomEndDate.getDate();

    return `${this.datePipe.transform(roomStartDate, 'd.MM.y, HH:mm - ')}${
      sameDay
        ? this.datePipe.transform(roomEndDate, 'HH:mm')
        : this.datePipe.transform(roomEndDate, 'd.MM.y, HH:mm')
    }`;
  }
}
